import React from 'react';
import { useAppData } from '../../context/Contexts';
import styles from './styles.module.scss';

const FIELDS = [
    'bundle_code',
    'video_url',
    'video_hero_img_url',
    'video_hero_img_title',
    'configurator_complete',
    'seat',
    'year',
    'make',
    'model',
    'trim',
    'cab',
    'step',
] as const;

const DevVideoDebug: React.FC = () => {
    if (!import.meta.env.DEV) return null;

    const { currentAppData } = useAppData();

    return (
        <div className={styles.panel}>
            <div className={styles.heading}>🛠 Dev — video fields</div>
            <table className={styles.table}>
                <tbody>
                    {FIELDS.map(key => (
                        <tr key={key}>
                            <td className={styles.key}>{key}</td>
                            <td className={styles.value}>
                                {formatValue(currentAppData?.[key])}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

function formatValue(v: unknown): string {
    if (v === undefined) return '—';
    if (v === null) return 'null';
    if (typeof v === 'boolean') return String(v);
    return String(v);
}

export default DevVideoDebug;
